const log = require("../shared_utils/log.js");

module.exports = function store(state, emitter) {
  emitter.on("pick-and-replace-glitch", (glitchId) => { 
    log("pick-and-replace-glitch", glitchId)
    if (state.selectedGlitchId){

    const i0 = state.toolbar.glitches.findIndex((id) => id === glitchId);
    state.toolbar.glitches[i0] = state.selectedGlitchId;
    const i = state.toolbar.items.findIndex((id) => id === glitchId);
    state.toolbar.items[i] = state.selectedGlitchId;
    }
    else if (state.selectedPartId){
      state.toolbar.glitches = state.toolbar.glitches.filter((id) => id !== glitchId)
      const i = state.toolbar.items.findIndex((id) => id === glitchId);
      state.toolbar.items[i] = state.selectedPartId;
      state.toolbar.parts.push(state.selectedPartId);
    }
    emitter.emit("render");
  });

  emitter.on("pick-and-replace-part", (partId) => {
    log("pick-and-replace-part", partId);
    if (state.selectedPartId) {

    const i0 = state.toolbar.parts.findIndex((id) => id === partId);
    state.toolbar.parts[i0] = state.selectedPartId;
    const i = state.toolbar.items.findIndex((id) => id === partId);
    state.toolbar.items[i] = state.selectedPartId;
    } else if (state.selectedGlitchId) {
      state.toolbar.parts = state.toolbar.parts.filter((id) => id !== partId);
      const i = state.toolbar.items.findIndex((id) => id === partId);
      state.toolbar.items[i] = state.selectedGlitchId
      state.toolbar.glitches.push(state.selectedGlitchId);
    }
    emitter.emit("render");
  });

  emitter.on("start-picking-glitch", (glitchId) => {
    log("start-picking-glitch");
    state.pickingGlitch = true;
    emitter.emit("select-glitch", glitchId);
  });
  emitter.on("start-picking-part", (partId) => {
    log("start-picking-part");
    state.pickingPart = true;
    emitter.emit("select-part", partId);
  });

  emitter.on("pick-glitch", () => {
    log("pick-glitch");
    state.pickingGlitch = false;
    const glitch = state.availableGlitches.find(
      (g) => g.id === state.selectedGlitchId
    );
    if (state.toolbar.glitches.includes(glitch.id)) {
      return;
    }
    state.toolbar.glitches.push(glitch.id);
    state.toolbar.items.push(glitch.id);
    emitter.emit("render");
  });
  emitter.on("pick-part", () => {
    log("pick-part");
    state.pickingPart = false;
    if (state.toolbar.parts.includes(state.selectedPartId)) {
      return;
    }
    const part = state.availableParts.find(
      (g) => g.id === state.selectedPartId
    );
    state.toolbar.parts.push(part.id);
    state.toolbar.items.push(part.id);
    emitter.emit("render");
  });
  emitter.on("load-pack-to-toolbar", (packId) => {
    log("load-pack-to-toolbar", packId);
    const pack = state.availablePacks.find((p) => p.id === packId);
    state.toolbar.glitches = pack.glitches;
    state.toolbar.parts = pack.parts;
    emitter.emit("render");
  });
};
